import React, { useRef } from 'react';
import { ColorBox } from './styles';

export const ColorChoice = ({ color, index, listColor, setListColor }) => {
  const selector = useRef();

  return (
    <>
      <ColorBox
        ref={selector}
        listColor={listColor}
        color={color}
        index={index}
        onClick={() => setListColor(index)}
      >
        <div></div>
      </ColorBox>
    </>
  );
};
